import {
  ALL_CHART_TYPES,
  BLACK_HEX,
  DEFAULT_LINE_THICKNESS,
  DEFAULT_NORMALIZE_BY,
  DEFAULT_NORMALIZE_BY_SETTING
} from "constants/chart.constants";
import { EvaSource, TimeStep } from "constants/charts.enums";
import { FIELD_NAMES } from "constants/fieldLabels.constants";
import { createMergeWithDefaults } from "entities/utils";
import { MaterialBalanceTimeChartSettings, MaterialBalanceTimeRequestType } from "types";

import { MaxBinsSortOrderEnum } from "models/binSize";
import { EntityKind } from "models/entityKind";

import { BASE_CHART_REQUEST } from "./defaults";

export const DEFAULT_MATERIAL_BALANCE_TIME_SETTINGS: Partial<MaterialBalanceTimeChartSettings> =
  {
    product: "Oil",
    chartType: ALL_CHART_TYPES.MaterialBalanceTime.id,
    showForecast: false,
    pdenDataSourceSetting: {
      source: EvaSource.Public,
      timeStep: TimeStep.Month
    },
    forecastMode: "forecastTrump",
    showIndividualSeries: true,
    useForecastStartDate: false,
    survivorBias: true,
    rateType: 0,
    averageSettings: {
      color: BLACK_HEX,
      thickness: DEFAULT_LINE_THICKNESS
    },
    showAverage: false,
    cutoff: 50,
    timeStep: TimeStep.Month,
    shutInMonths: 3,
    source: EvaSource.Public,
    normalizeBy: DEFAULT_NORMALIZE_BY,
    useWeightedRatioAverage: true,
    xVariable: {
      valueProperty: "Performance.Oil.TwelveMCalTimeCum.fcst",
      displayTitle: "12M CalTime Cum + Forecast (Mbbl)",
      canBin: true,
      dataType: "Number",
      mappingName: "Performance.Oil.TwelveMCalTimeCum.fcst",
      bin: null
    },
    yVariable: {
      valueProperty: "Well_Design.HzLength_m",
      displayTitle: FIELD_NAMES.HZ_LENGTH,
      canBin: true,
      dataType: "Number",
      mappingName: "Well_Design.HzLength_m"
    },
    lockUnits: false,
    movingAverageDays: null
  };

export const DEFAULT_MATERIAL_BALANCE_TIME_REQUEST: Partial<MaterialBalanceTimeRequestType> =
  {
    ...BASE_CHART_REQUEST,
    FilterId: "",
    requestId: "",
    ReverseColor: false,
    ColorPalette: {
      id: "-6",
      name: "Portland",
      shared: false,
      colors: [],
      preferredColors: [],
      paletteType: 0,
      colorScale: [],
      specialColors: null,
      thickness: [2],
      reverse: false
    },
    GroupBy: {
      title: "Resource Play",
      property: "Header.ResourcePlay",
      groupByField: "Header.ResourcePlay",
      pdenSource: "Public",
      canBin: false,
      dataType: "Text", // TODO: check this
      categoryId: 1,
      tooltip: "",
      display: "",
      entityKind: EntityKind.Well,
      bin: {
        BinSize: 0,
        MinSize: null,
        MaxBins: null,
        MaxBinsSortOrder: MaxBinsSortOrderEnum.WellCount,
        GreaterThan: null,
        LessThan: null,
        Quantile: {
          quantileType: "NumberOfQuantile",
          numQuantiles: 4
        },
        BinType: "BinSize",
        UseDynamicBins: false
      },
      mode: undefined,
      forecastTrumpingSettings: undefined,
      performanceDateRange: undefined
    },
    sortBy: "AlphabeticalAsc",
    userForecast: [],
    userForecastSettings: {
      forecastSourceFolder: null,
      excludeMcDanielForecasts: false,
      reserveCategory: null,
      excludeNoviForecasts: true,
      specialForecastFolders: ["McDaniel Research"]
    },
    forecastMode: "forecastTrump",
    useForecastStartDate: false,
    showGroupsNotInFilter: true,
    placeholderBinsEnabled: false,
    hasCheckedBins: true,
    syncClientPden: false,
    syncClientSchema: "",
    colorLockedItems: {},
    syncClientFcst: false,
    syncForecastRescat: "2111",
    normalizeBySetting: DEFAULT_NORMALIZE_BY_SETTING,
    chartSetting:
      DEFAULT_MATERIAL_BALANCE_TIME_SETTINGS as MaterialBalanceTimeChartSettings,
    axisMinMax: {
      xMin: null,
      xMax: null,
      yMin: null,
      yMax: null
    },
    isDefaultLockOn: true
  };

export const generateMaterialBalanceTimeRequestBody = createMergeWithDefaults(
  DEFAULT_MATERIAL_BALANCE_TIME_REQUEST
);
